// System
import { Button } from '@mui/material';
// Components
import FormProvider from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateAviatorPermissionContent } from './CreateAviatorPermissionContent';
// Form
import { useCreateAviatorPermissionForm } from '@Forms/aviatorPermissions/CreateAviatorPermissionFormContext';
// Redux
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';

export const CreateAviatorPermissionForm = () => {
  const methods = useCreateAviatorPermissionForm();
  const {
    handleCloseCreateAviatorPermissionModalDialog,
    submittable,
    handleSubmitCreateAviatorPermission,
  } = useAviatorPermissions();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateAviatorPermissionContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleCloseCreateAviatorPermissionModalDialog}
            >
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateAviatorPermission}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
